import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/view/HelloWorld";
import { store } from "xijs";
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [
    {
      path: "/sidebar",
      name: "sidebar",
      component: () => import("../view/sidebar/sidebar"),
      meta: {
        title: "文件上传下载"
      }
    },
    {
      path: "/examination",
      name: "examination",
      component: () => import("../view/examination/index"),
      meta: {
        title: "审核任务"
      }
    },
    {
      path: "/download",
      name: "download",
      component: () => import("../view/downloadAllFile/downloadAllFile"),
      meta: {
        title: "文件列表下载"
      }
    },
    {
      path: "/sourceMaterial",
      name: "sourceMaterial",
      component: () => import("../view/sourceMaterial/sourceMaterial"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/siftIndex",
      name: "siftIndex",
      component: () => import("../view/siftIndex/siftIndex"),
      meta: {
        title: "筛选"
      }
    },
    {
      path: "/uploadFile",
      name: "uploadFile",
      component: () => import("../view/uploadFile/uploadFile"),
      meta: {
        title: "上传"
      }
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../view/login/login"),
      meta: {
        title: " "
      }
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../view/home/home"),
      meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        title: "锤子AI流程"
      },
      // redirect: "/publish-theme",
      children: [
        {
          path: "/PlatformView-videoscript",
          name: "PlatformView-videoscript",
          component: () => import("@/view/writingPlatform/videoScript"),
          meta: {
            requireAuth: true,
            title: "短视频编剧"
          }
        },
        {
          path: "/PlatformView-examination",
          name: "PlatformView-examination",
          component: () => import("@/view/writingPlatform/examinationIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "审查"
          }
        },
        
        
        {
          path: "/PlatformView-videoscript",
          name: "PlatformView-videoscript",
          component: () => import("@/view/writingPlatform/videoScript"),
          meta: {
            requireAuth: true,
            title: "短视频编剧"
          }
        },
        {
          path: "/PlatformView-sourcematerial",
          name: "PlatformView-sourcematerial",
          component: () => import("@/view/writingPlatform/sourceMaterial"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "素材"
          }
        },
        {
          path: "/PlatformView-videoscript",
          name: "PlatformView-videoscript",
          component: () => import("@/view/writingPlatform/videoScript"),
          meta: {
            requireAuth: true,
            title: "短视频编剧"
          }
        },
        {
          path: "/PlatformView-topic",
          name: "PlatformView-topic",
          component: () => import("@/view/writingPlatform/topicIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "选题"
          }
        },
        {
          path: "/PlatformView-lucas",
          name: "PlatformView-lucas",
          component: () => import("@/view/writingPlatform/lucasindex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "LUCAS"
          }
        },
        {
          path: "/PlatformView-kxccbqb",
          name: "PlatformView-kxccbqb",
          component: () => import("@/view/writingPlatform/kxccqbq"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "开心锤锤表情包"
          }
        },{
          path: "/PlatformView-bqbdatas",
          name: "PlatformView-bqbdatas",
          component: () => import("@/view/writingPlatform/newbqbdata"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "表情包数据"
          }
        },
        {
          path: "/PlatformView-bqbindex",
          name: "PlatformView-bqbindex",
          component: () => import("@/view/writingPlatform/bqbIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "表情包"
          }
        },
        {
          path: "/PlatformView-bqbdelivery",
          name: "PlatformView-bqbdelivery",
          component: () => import("@/view/writingPlatform/bqbdelivery"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "表情包商品发货"
          }
        },
        {
          path: "/PlatformView-bqbluck",
          name: "PlatformView-bqbluck",
          component: () => import("@/view/writingPlatform/bqbluck"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "表情包抽奖"
          }
        },
        {
          path: "/PlatformView-bqbsource",
          name: "PlatformView-bqbsource",
          component: () => import("@/view/writingPlatform/bqbsource"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "表情包素材"
          }
        },{
          path: "/PlatformView-reply",
          name: "PlatformView-reply",
          component: () => import("@/view/writingPlatform/replyIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "建议"
          }
        },
        {
          path: "/PlatformView-canteen",
          name: "PlatformView-canteen",
          component: () => import("@/view/writingPlatform/canteenIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "菜单"
          }
        },
        {
          path: "/PlatformView-music",
          name: "PlatformView-music",
          component: () => import("@/view/writingPlatform/musicIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "小样"
          }
        },
        {
          path: "/PlatformView-screen",
          name: "PlatformView-screen",
          component: () => import("@/view/writingPlatform/musicScreen"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "筛选"
          }
        },
        {
          path: "/PlatformView-bitable",
          name: "PlatformView-bitable",
          component: () => import("../view/writingPlatform/bitableIndex"),
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: "多维表格"
          }
        },
      ]
    },
  ]
});




router.beforeEach((to, from, next) => {
  document.title = to.matched[0].meta.title;
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    let { value } = store.get("kxccAI_token");
    if (value) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js